<script lang='ts'>
export default { name: 'GBadgeNew' }
</script>

<script lang='ts' setup>
</script>

<template>
  <section class="flex items-center bg-green-5 py-1 px-2 rounded-full">
    <p v-if="$slots.default" class="text-green-1 text-2 font-semibold leading-none">
      <slot />
    </p>
  </section>
</template>

<style lang='scss' scoped>

</style>
